<template>
<span title="This object is inaccessible or references an entity which no longer exists">{{content}}</span>
</template>

<script>

export default {
	name: "JmUuid",

	props: {
		content: [ String, Number ]
	}
};
</script>

<style lang="stylus" scoped>
span
	font-family courier, monospace
	border 1px solid lightgray
	border-left none
	border-right none
	border-radius 4px
	padding 1px 4px
	font-size 80%
</style>



// WEBPACK FOOTER //
// src/components/widgets/ItemViewWidgets/Uuid.vue